import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axiosConfig";
import "./SuperAdminLogin.css";

// Dedicated site-owner login screen. Same backend endpoint as the
// regular login, but the UI reads as an admin console and any
// non-super_admin credential is rejected client-side so a stray staff
// user can't accidentally land here. The backend still owns the real
// authorization on every request.
export default function SuperAdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post("/superadmin/login", { email, password });
      const sa = res.data?.superAdmin;
      const token = res.data?.token;
      if (!sa || !token) {
        setError("Invalid response from server.");
        return;
      }
      // Dedicated token keyed as `sa_token` so tenant sessions and
      // site-owner sessions never overwrite each other.
      localStorage.setItem("sa_token", token);
      localStorage.setItem("superAdmin", JSON.stringify(sa));
      window.location.href = "/super-admin";
    } catch (err) {
      setError(
        err?.message || err?.error || err?.details || "Login failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sal-shell">
      <div className="sal-card">
        <div className="sal-brand">
          <div className="sal-logo">SA</div>
          <div>
            <h1>Site owner console</h1>
            <p>Restricted access. Super admin credentials only.</p>
          </div>
        </div>
        <form onSubmit={submit}>
          {error && <div className="sal-error">{error}</div>}
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
            autoComplete="username"
          />
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
          <button type="submit" disabled={loading}>
            {loading ? "Signing in…" : "Enter console"}
          </button>
        </form>
        <div
          className="sal-hint"
          onClick={() => navigate("/login")}
          role="button"
        >
          Regular user? Sign in here →
        </div>
      </div>
    </div>
  );
}
